import type { DocumentDownloadType } from '../../../api/models/user.model';
import { useDocumentDownloadQuery } from '../../../api/user.api';
import {
	DISCLOSURE_ERECORDS_DOCUMENT_TITLE,
	DISCLOSURE_TERMS_DOCUMENT_TITLE,
} from '../../../constants/messages';
import DocumentModal from '../DocumentModal/DocumentModal';

export type DisclosureType = Extract<DocumentDownloadType, 'ERECORDS' | 'TERMS'>;
export type DisclosureDocumentModalProps = {
	onClose: () => void;
	type: DisclosureType;
};

const getProps = (type: DisclosureType) => {
	switch (type) {
		case 'ERECORDS':
			return { title: DISCLOSURE_ERECORDS_DOCUMENT_TITLE, filename: 'Circadia_Electronic_Records' };
		case 'TERMS':
			return { title: DISCLOSURE_TERMS_DOCUMENT_TITLE, filename: 'Circadia_Terms_and_Conditions' };
	}
};

export const DisclosureDocumentModal = ({ onClose, type }: DisclosureDocumentModalProps) => {
	const { data, isLoading, isError } = useDocumentDownloadQuery({ documentDownloadType: type });
	const { filename, title } = getProps(type);

	return <DocumentModal {...{ data, filename, isError, isLoading, onClose, title }} />;
};
